/**
 * Customize / Print / Export: compact secondary actions beside the filter
 * chips. The brand theme sets every Button's text to 16px through the theme's
 * `styles`, which Mantine renders as an inline style that a CSS class can't
 * override, so the smaller text goes through `styles` as well.
 */
export const COMPACT_BUTTON_PROPS = {
  size: "xs",
  styles: { root: { fontSize: "var(--font-size-caption)" } },
} as const;
